import { IconButton, IconButtonProps } from '@chakra-ui/react'
import { FunctionComponent, useRef } from 'react'
import { Transition } from 'react-transition-group'

import { Icon } from '../Icons/Icon'
import { SidenavTooltip } from './Sidenav.parts'

interface ExpandButtonProps {
  isExpanded: boolean
  onExpandClick: () => void
}

const transitions: any = {
  entering: {
    transition: `all 250ms ease-in 600ms`,
    right: '16px',
  },
  entered: {
    right: '16px',
  },
  exiting: {
    transition: `all 250ms ease-in`,
    right: '-12px',
  },
  exited: {
    right: '-12px',
  },
}

export const ExpandButton: FunctionComponent<ExpandButtonProps> = ({
  isExpanded = false,
  onExpandClick = () => {},
}) => {
  const expandStyles: Partial<IconButtonProps> = isExpanded
    ? {
        backgroundColor: 'presets.turquoise.100',
        borderColor: 'presets.turquoise.30',
        transform: 'rotate(0deg)',
        color: 'presets.turquoise.30',
      }
    : {
        backgroundColor: 'presets.neutral.0',
        borderColor: 'presets.turquoise.100',
        transform: 'rotate(180deg)',
        color: 'presets.turquoise.100',
      }
  const ref = useRef(null)

  return (
    <Transition nodeRef={ref} in={isExpanded} timeout={0}>
      {state => (
        <SidenavTooltip
          label={isExpanded ? 'Hide Menu' : 'Show Menu'}
          marginLeft={isExpanded ? '15px' : '0px'}
        >
          <IconButton
            ref={ref}
            onClick={onExpandClick}
            position="absolute"
            {...transitions[state]}
            data-testid="prime-sidenav"
            data-expanded={isExpanded}
            p="6px"
            mb="17px"
            border="1px solid"
            transition="all ease 400ms"
            _hover={{
              backgroundColor: 'presets.turquoise.80',
              borderColor: 'presets.turquoise.80',
              color: 'presets.neutral.0',
            }}
            icon={<Icon icon="DoubleChevronIcon" boxSize="10px" />}
            {...expandStyles}
            {...transitions[state]}
          ></IconButton>
        </SidenavTooltip>
      )}
    </Transition>
  )
}
